import React, { useMemo } from 'react';
import { Paper, Select, MenuItem, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { EmailTemplateAdmin, EmailTemplateAdminService, Provider } from 'us-web-services';
import { Table, TableInstance } from 'src/components/common/Table';
import PageStyles from '../../styles/PageStyles';

function TxnEmailTemplates() {
  const tableRef = React.useRef<TableInstance>();
  const { classes } = PageStyles();

  const handleProviderChange = async (row: EmailTemplateAdmin, provider: Provider) => {
    try {
      await EmailTemplateAdminService.partialUpdate(row.id, {
        id: row.id,
        currentProvider: provider,
        mailchimpTemplateId: row.mailchimpTemplateId,
      });
      toast.success('Template updated');
      tableRef.current?.fetchData();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.errors?.[0]?.message ||
       error?.response?.data?.message || 'Failed to update template';

      toast.error(errorMessage);
    }
  };

  const handleMailchimpTemplateChange = async (row: EmailTemplateAdmin, mailchimpId: string) => {
    try {
      await EmailTemplateAdminService.partialUpdate(row.id, {
        id: row.id,
        currentProvider: row.currentProvider,
        mailchimpTemplateId: mailchimpId,
      });
      toast.success('Template updated');
      tableRef.current?.fetchData();
    } catch (error: any) {
      const errorMessage = error?.response?.data?.errors?.[0]?.message ||
       error?.response?.data?.message || 'Failed to update template';

      toast.error(errorMessage);
    }
  };

  const params = (searchQuery: string) => [
    { key: 'query', value: searchQuery || '' },
  ];

  const COLUMNS = useMemo(
    () => [
      {
        id: 'emailTemplates',
        header: 'Transactional Email Templates',
        columns: [
          {
            accessorKey: 'id',
            header: 'ID',
            enableEditing: false,
            size: 60,
          },
          {
            accessorKey: 'key',
            header: 'Key',
            enableEditing: false,
          },
          {
            accessorKey: 'name',
            header: 'Name',
            enableEditing: false,
          },
          {
            accessorKey: 'currentProvider',
            header: 'Provider',
            Cell: ({ cell }) => {
              const row = cell.row.original as EmailTemplateAdmin;

              return (
                <Select
                  size='small'
                  value={row.currentProvider}
                  onChange={e => handleProviderChange(row, e.target.value as Provider)}
                >
                  <MenuItem value='SENDGRID'>SendGrid</MenuItem>
                  <MenuItem value='MAILCHIMP'>Mailchimp</MenuItem>
                </Select>
              );
            },
          },
          {
            accessorKey: 'mailchimpTemplateId',
            header: 'Mailchimp Template ID',
            Cell: ({ cell }) => {
              const row = cell.row.original as EmailTemplateAdmin;

              return (
                <TextField
                  size='small'
                  defaultValue={row.mailchimpTemplateId || ''}
                  onBlur={e => handleMailchimpTemplateChange(row, e.target.value)}
                />
              );
            },
          },
        ],
      },
    ],
    [],
  );

  return (
    <Paper className={classes.paper}>
      <Table
        ref={tableRef}
        columns={COLUMNS}
        retrieveData={EmailTemplateAdminService.getByFilter}
        params={params}
        enableInlineEditing={false}
        alwaysApplyParams
      />
    </Paper>
  );
}

export default TxnEmailTemplates;
